import { ChartDatum, DateRangeEntry, DateValueTuple } from "../types";

export const toSeriesRecord = (values: DateValueTuple[]) =>
  values.reduce<Record<string, number>>((accumulator, [dateKey, value]) => {
    accumulator[dateKey] = value;
    return accumulator;
  }, {});

export const combineDateSeries = (
  series: Record<string, Record<string, number>>,
  dateEntries?: DateRangeEntry[] | string[],
  missingValue: number | null = null,
): ChartDatum[] => {
  const combinedDateEntries =
    dateEntries?.map(entry =>
      typeof entry === "string"
        ? { key: entry, dateLabel: entry }
        : { key: entry.key, dateLabel: entry.tooltipLabel ?? entry.label },
    ) ??
    Array.from(
      new Set(Object.values(series).flatMap(seriesValues => Object.keys(seriesValues))),
    ).map(key => ({ key, dateLabel: key }));

  return combinedDateEntries.map(({ key, dateLabel }) => {
    const datum: ChartDatum = { date: key, dateLabel };

    Object.entries(series).forEach(([seriesKey, seriesValues]) => {
      datum[seriesKey] = seriesValues[key] ?? missingValue;
    });

    return datum;
  });
};

export const hasChartData = (data: ChartDatum[]) =>
  data.some(datum =>
    Object.entries(datum).some(
      ([key, value]) => key !== "date" && typeof value === "number" && value > 0,
    ),
  );
